import {SvgIcon, useTheme} from '@mui/material';

export default function SelectArrowIcon() {
	const theme = useTheme();
	return (
		<SvgIcon className="w-4 h-4" width="16" height="16" viewBox="0 0 16 16" fill="none">
			<path fillRule="evenodd" clipRule="evenodd"
			      d="M2.24848 5.49531C2.50883 5.23496 2.93094 5.23496 3.19129 5.49531L7.53796 9.84198C7.79095 10.095 8.20883 10.095 8.46182 9.84198L12.8085 5.49531C13.0688 5.23496 13.4909 5.23496 13.7513 5.49531C14.0116 5.75566 14.0116 6.17777 13.7513 6.43812L9.40463 10.7848C8.63094 11.5585 7.36883 11.5585 6.59515 10.7848L2.24848 6.43812C1.98814 6.17777 1.98814 5.75566 2.24848 5.49531Z"
			      fill={theme.palette.mode === 'light' ? theme.palette.grey[700] : theme.palette.primary.main}/>
		</SvgIcon>
	);
}
